import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import  { useRef,useEffect,useState } from "react";
import {Box, Typography, Modal, Button, TextField, InputLabel, Select, MenuItem, FormControl, List, ListItem, ListItemText} from '@mui/material';
import { Link } from 'react-router-dom';


function CreditNoticeModal(props: any) {
    const [isOpen, setIsOpen] = useState(false);
    const [scroll, setScroll] = useState<DialogProps['scroll']>('paper');

    const modalStyle = {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-5%, -60%)',
        width: '40%',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
      };

      function handleOpen() {
        setIsOpen(true);
        setScroll("paper");
      };

      const descriptionElementRef = useRef<HTMLElement>(null);

      useEffect(()=>{
        setIsOpen(props.isOpen);
      });
    return (
    <>



        <Dialog
            open={isOpen}
            fullWidth={true}
            maxWidth={"md"}
            onBackdropClick={props.onCloseModal}
            scroll={scroll}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
        <DialogTitle id="scroll-dialog-title">Credit Notice</DialogTitle>
        <DialogContent onClick={(e)=>{e.preventDefault();}} dividers={scroll === 'paper'}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            In The Car and its subsidiaries collect information from you and other third-party sources and may share your information 
            with third parties without your authorization, as permitted or required by law. We review your credit report and the credit 
            report of any individual listed in the application or obtain or use an insurance credit score based on the information contained 
            in the credit report, where permitted by law. We may use a third party in connection with the development of your insurance 
            credit score. You may request that your credit information be updated and if you question the accuracy of the credit information, 
            we will, upon your request, re-evaluate you based on corrected credit information from a consumer reporting agency. Examples of 
            the type of information collected are driving records, driving history, insurance claims histories, credit reports and credit-based 
            insurance scores. Once you become a { process.env.REACT_APP_TXT_CUSTOMER?.toLowerCase() ?? "customer"}, ITC may continue to use your consumer reports to update or renew your insurance policy. 
            Please review our Privacy Policy, which describes ITC use of collected information, and our Terms and Conditions.
        
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.onCloseModal}>Close</Button>
        </DialogActions>
      </Dialog>
    </>);
}

export default CreditNoticeModal;